import {match} from 'ts-pattern';

import {SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

import {FINANCING_COST_OVERRIDES} from '../constants/FINANCING_COST_OVERRIDES';
import {withFinancingBodyField} from './withFinancingBodyField';

/**
 * Clears the overrides the current tenant can see. An override hidden from the tenant stays as it
 * is, because the user never had the chance to review it.
 *
 * A manual configuration has no template to fall back to, so its interest rate type returns to the
 * fixed rate the field shows instead of `null` (see `createManualFinancingBody`).
 */
export function resetVisibleFinancingOverrides(
  body: SaveSaleVehicleFinancingBody,
  isGermanTenant: boolean
) {
  const commonReset = {
    ...body,
    processingFeeOverride: null,
  };

  return match(isGermanTenant)
    .with(true, () =>
      FINANCING_COST_OVERRIDES.reduce<SaveSaleVehicleFinancingBody>(
        (reset, override) =>
          withFinancingBodyField(
            withFinancingBodyField(reset, override.includedOverrideKey, null),
            override.amountOverrideKey,
            null
          ),
        {
          ...commonReset,
          interestRateTypeOverride: body.mode === 'MANUAL' ? 'FIXED' : null,
          tradeInPossibleOverride: null,
        }
      )
    )
    .with(false, () => commonReset)
    .exhaustive();
}
